export default __webpack_public_path__ + "static/9-c1466fa7ada000ecad2bc03c5d8707ac.jpg";